import useCheckMobileScreen from 'hooks/use-check-mobile-screen'
import FtuxModalWithPagination from './FtuxModalWithPagination'
import { ReactComponent as GraphicOne } from './email-responder-onboarding-1.svg'

const GmailFtuxModal = ({ onClose, onFinish }: { onClose: () => void; onFinish: () => void }) => {
  const isMobile = useCheckMobileScreen()

  const ftuxModalPages = [
    {
      icon: (
        <GraphicOne
          style={{
            width: isMobile ? '100%' : '702px',
          }}
        />
      ),
      headerText: 'Get automated drafts!',
      subtitleText:
        'Your digital twin can automatically draft intelligent email responses to select emails by incorporating your data and response patterns.',
    },
  ]

  return <FtuxModalWithPagination onClose={() => {}} onFinish={onFinish} pages={ftuxModalPages} />
}

export default GmailFtuxModal
